export const TOGGLE_LOADING_INDICATOR = 'TOGGLE_LOADING_INDICATOR'

export const toggleLoadingIndicator = (on) => ({
  type: TOGGLE_LOADING_INDICATOR,
  on,
})
